import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser'

const state = {
  msalInstance: null,
  isAuthenticated: false,
  user: null,
  msalConfig: null,
  accessToken: null
}

const getters = {
  msalInstance: state => state.msalInstance,
  isAuthenticated: state => state.isAuthenticated,
  user: state => state.user,
  msalConfig: state => state.msalConfig,
  accessToken: (state) => {
    if (state.accessToken) return state.accessToken
    else {
      const sessionToken = sessionStorage.getItem('yhrs_accessToken');
      return sessionToken != null ? JSON.parse(sessionToken) : null;
    }
  }
}

const mutations = {
  setMsalInstance: (state, msalInstance) => {
    state.msalInstance = msalInstance
  },
  setIsAuthenticated: (state, isAuthenticated) => {
    state.isAuthenticated = isAuthenticated
  },
  setUser: (state, user) => {
    state.user = user
  },
  setMsalConfig: (state, msalConfig) => {
    state.msalConfig = msalConfig;
  },
  setAccessToken: (state, token) => {
    state.accessToken = token;
    sessionStorage.setItem('yhrs_accessToken', JSON.stringify(token));
  }
}

const actions = {
    initializeMsalInstance: async ({ commit }, msalConfig) => {
        const msalInstance = new PublicClientApplication(msalConfig)
        commit('setMsalInstance', msalInstance)
        commit('setMsalConfig', msalConfig)
    },
  loginRedirect: async ({ state }) => {
    return await state.msalInstance.loginRedirect({
      scopes: ['openid', 'profile', 'email']
    })
  },
  passwordReset: ({ state }) => {
    state.msalInstance.loginRedirect({
      authority: "https://yourhrsystemb2c.b2clogin.com/yourhrsystemb2c.onmicrosoft.com/B2C_1A_PASSWORDRESET"
    })
  },
  handleRedirectPromise: async ({ getters, dispatch, commit }) => {
    const msalInstance = getters.msalInstance;
    return msalInstance.handleRedirectPromise().then(async (response) => {

    // Try to get the active account from the cache
    const accounts = await msalInstance.getAllAccounts()

      if (accounts.length > 0) {
          // Set the active account to the first account in the cache
          msalInstance.setActiveAccount(accounts[0])
          commit('setIsAuthenticated', true);
          commit('setUser', accounts[0]);
          return msalInstance;
      } else {
          // Redirect the user to login
          await dispatch('loginRedirect')
          return msalInstance;
      }
    }).catch((error) => {
      if (error.errorMessage.indexOf('AADB2C90091') > -1) { // User cancelled the flow
        dispatch('logout');
      }
      else if (error.errorMessage.indexOf("AADB2C90118") > -1) {
        try {
          dispatch('passwordReset');
        } catch(passwordResetErr) {
          console.log(passwordResetErr);
          dispatch('logout')
        }
      } else {
        dispatch('logout')
      }
    })
  },
  acquireTokenSilent: async ({ state, commit, getters, dispatch }, options = {}) => {
    const account = state.user || (state.msalInstance && state.msalInstance.getActiveAccount ? state.msalInstance.getActiveAccount() : null)
    const allowInteractiveFallback = options.interactive !== false;

    if (!account) {
      if (!allowInteractiveFallback) return null;

      await dispatch('loginRedirect');
      return null;
    }

    return await state.msalInstance.acquireTokenSilent({
      account: account,
      scopes: getters.msalConfig.scopes,
      forceRefresh: !!options.forceRefresh
    }).then(accessToken => {
        commit('setAccessToken', accessToken);
        return accessToken;
    }).catch(async error => {
      if (!allowInteractiveFallback) throw error;

      if (error instanceof InteractionRequiredAuthError) {
        return await dispatch('acquireTokenRedirect')
      } else {
        return await dispatch('loginRedirect')
      }
    })
  },
  acquireTokenRedirect: ({ state, getters }) => {
    state.msalInstance.acquireTokenRedirect({
      scopes: getters.msalConfig.scopes
    })
  },
  logout: ({ state }) => {
    sessionStorage.removeItem('yhrs_accessToken');
    state.msalInstance.logout()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
